// Module
var code = "<p><a href=\"introduction/committee\">Committee members</a> may propose changes to the dynamic parameters of the blockchain, such as fees, block time and many other things. It is a position of great responsibility that requires a good understanding of how BitShares works.</p> ";
// Exports
export default code;